// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-rule-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.custom-rule-table th,
.custom-rule-table td {
  padding-top: 10px;
  padding-bottom: 8px;
  padding-left: 14px;
  border: 1px solid #d9d9d9;
  text-align: left;
  font-size: 10px;
}
.custom-rule-table thead {
  top: 0px !important;
  width: 150px;
}
.custom-rule-table th {
  background-color: #f4f4f4;
  position: sticky;
  top: 0;
  z-index: 100;
  border-top: 0.3px solid #f4f4f4;
  border-bottom: 1px solid #d9d9d9;
  text-align: left;

  color: #808697;
}
.custom-rule-table .rule_header_checkbox {
  color: #808697;
  font-size: 12px;
  font-weight: 400;
}
.custom-rule-table .table_rule_header {
  padding-top: 0;
  padding-bottom: 0;
  height: 35px;
  background-color: #f4f4f4;
}
.custom-rule-table th:first-child,
.custom-rule-table td:first-child {
  width: 30px;
  line-height: 10px;
}

.custom-rule-table th:nth-child(2),
.custom-rule-table td:nth-child(2) {
  width: 70px;
  /* line-height: 10px; */
}

.table-rule-container {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  border-top: 0.1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  position: relative;
  scrollbar-width: thin;
}

.custom-rule-table tbody tr {
  background-color: #ffffff;
  height: 39px;
  vertical-align: initial;
}

.custom-rule-table tbody td {
  font-weight: 400;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderTableComponent/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;;EAEhB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".custom-rule-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.custom-rule-table th,\n.custom-rule-table td {\n  padding-top: 10px;\n  padding-bottom: 8px;\n  padding-left: 14px;\n  border: 1px solid #d9d9d9;\n  text-align: left;\n  font-size: 10px;\n}\n.custom-rule-table thead {\n  top: 0px !important;\n  width: 150px;\n}\n.custom-rule-table th {\n  background-color: #f4f4f4;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  border-top: 0.3px solid #f4f4f4;\n  border-bottom: 1px solid #d9d9d9;\n  text-align: left;\n\n  color: #808697;\n}\n.custom-rule-table .rule_header_checkbox {\n  color: #808697;\n  font-size: 12px;\n  font-weight: 400;\n}\n.custom-rule-table .table_rule_header {\n  padding-top: 0;\n  padding-bottom: 0;\n  height: 35px;\n  background-color: #f4f4f4;\n}\n.custom-rule-table th:first-child,\n.custom-rule-table td:first-child {\n  width: 30px;\n  line-height: 10px;\n}\n\n.custom-rule-table th:nth-child(2),\n.custom-rule-table td:nth-child(2) {\n  width: 70px;\n  /* line-height: 10px; */\n}\n\n.table-rule-container {\n  width: 100%;\n  max-height: 400px;\n  overflow-y: auto;\n  border-top: 0.1px solid #d9d9d9;\n  border-bottom: 1px solid #d9d9d9;\n  position: relative;\n  scrollbar-width: thin;\n}\n\n.custom-rule-table tbody tr {\n  background-color: #ffffff;\n  height: 39px;\n  vertical-align: initial;\n}\n\n.custom-rule-table tbody td {\n  font-weight: 400;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
